import Block from './Block'
import gsap from 'gsap'
import App from '../App'

export default class InfiniteText extends Block {

  constructor(el, destroyLast) {
    super(el, destroyLast)

    this.destroyLast = true
    this.el.classList.add('play-animation')

    this.setSizes()
  }

  getElems() {
    super.getElems()

    this.items = this.el.querySelectorAll('.infinite-text__item')
  }

  resize() {
    super.resize()

    this.setSizes()
  }

  setSizes() {
    if (!this.items) return

    let height = 0

    for (let i = 0; i < this.items.length; i++) {
        const eltHeight = this.items[i].offsetHeight

        height = eltHeight > height ? eltHeight : height
    }

    gsap.set(this.el, {
        height
    })

    App.smoothScroll.update()
  }

  destroy() {
    this.el.classList.remove('play-animation')
    this.el.classList.remove('play-animation-menu')
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/InfiniteText.js